// extracted by mini-css-extract-plugin
module.exports = {"wrap-crumbs":"BreadCrumbs_wrap-crumbs__QThb_","crumbs":"BreadCrumbs_crumbs__3gvQj"};